import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../../components/customTable/CustomTable";
import NameDateSearchComponent from "../../../components/customTable/NameDateSearchComponent";
import ToastComponent from "../../../components/customTable/ToastComponent";
import { useCallback, useEffect, useState } from "react";
import { createMRTColumnHelper } from "material-react-table";
import { toast } from "react-toastify";
import { Box, IconButton, Tooltip } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { missingSipApi } from "../../../app/slices/reports/missingSipSlice";

export default function MissingSip() {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);

  const sliceResponse = useSelector(
    (state) => state.missingSip.missingSip.data
  );
  const stateLoading = useSelector(
    (state) => state.missingSip.loading
  );
  useEffect(() => {
    if (sliceResponse) {
      const formattedData = sliceResponse?.map((originalData) => ({
        id: originalData._id || "N/A",
        clientId: originalData.client_id?._id || "N/A",
        clientName: originalData.client_id?.name || "N/A",
        partnerId: originalData.partner_id || "N/A",
        proposalNo: originalData.proposal_no || "N/A",
        orderType: originalData.order_type || "N/A",
        metalType: originalData.metal_type || "N/A",
        amount: originalData.amount || "N/A",
        quantity: originalData.quantity || "N/A",
        price: originalData.Price || "N/A",
        goldlivePrice: originalData.LivePrice[0].gBuy || "N/A",
        silverlivePrice: originalData.LivePrice[0].sBuy || "N/A",
        blockId: originalData.Blockid || "N/A",
        status: originalData.status || "N/A",
        proposalType: originalData.proposal_type || "N/A",
        dayOfMonth: originalData.day_of_month || "N/A",
        frequency: originalData.frequency || "N/A",
        isDeleted: originalData.is_deleted || "N/A",
        flag: originalData.flag || "N/A",
        createdAt: originalData.createdAt || "N/A",
        updatedAt: originalData.updatedAt || "N/A",
        sipStatus: originalData.sip_status || "N/A",
        subReferenceId: originalData.subReferenceId || "N/A",
        subscriptionId: originalData.subscriptionId || "N/A",
      }));
      setData(formattedData || []);
    }
  }, [sliceResponse]);

  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });

  // Memoized function to dispatch the API call with the necessary parameters
  const fetchData = useCallback(() => {
    let params = {};
    params.name = queryParams.customerName;
    params.startDate = queryParams.startDate;
    params.endDate = queryParams.endDate;
    if (Object.keys(params).length > 0) {
      dispatch(missingSipApi(params)); // Dispatch API call even when reset (empty search term or date)
    }
  }, [dispatch, queryParams]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleSearchByDate = (startDate, endDate, customerName) => {
    setQueryParams({ startDate, endDate, customerName });
  };

  const columnHelper = createMRTColumnHelper();

  const columns = [
    columnHelper.accessor("id", {
      header: "ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row?.original?.id);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row?.original?.id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("clientName", {
      header: "Client Name",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original?.clientName}
        </div>
      ),
    }),
    columnHelper.accessor("partnerId", {
      header: "Partner ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row?.original?.partnerId);
          toast.success("Copied to clipboard!");
        };
        return (
          <>
            <Tooltip title={cell.row?.original?.partnerId}>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
            </Tooltip>
            {cell.row?.original?.partnerId}
          </>

        );
      },
    }),
    columnHelper.accessor("proposalNo", {
      header: "Proposal No",
      size: 30,
    }),
    columnHelper.accessor("orderType", {
      header: "Order Type",
      size: 30,
    }),
    columnHelper.accessor("metalType", {
      header: "Metal Type",
      size: 30,
    }),
    columnHelper.accessor("amount", {
      header: "Amount",
      size: 30,
    }),
    columnHelper.accessor("quantity", {
      header: "Quantity",
      size: 30,
    }),
    columnHelper.accessor("price", {
      header: "Price",
      size: 30,
    }),
    columnHelper.accessor("goldlivePrice", {
      header: "Gold Buy Price",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original?.goldlivePrice}
        </div>
      ),
    }),
    columnHelper.accessor("silverlivePrice", {
      header: "Silver Buy Price",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original?.silverlivePrice}
        </div>
      ),
    }),
    columnHelper.accessor("blockId", {
      header: "Block ID",
      size: 30,
    }),
    // columnHelper.accessor("status", {
    //     header: "Status",
    //     size: 30,
    // }),
    columnHelper.accessor("proposalType", {
      header: "Proposal Type",
      size: 30,
    }),
    columnHelper.accessor("dayOfMonth", {
      header: "Day of Month",
      size: 30,
    }),
    columnHelper.accessor("frequency", {
      header: "Frequency",
      size: 30,
    }),
    columnHelper.accessor("sipStatus", {
      header: "SIP Status",
      size: 30,
    }),
    columnHelper.accessor("subReferenceId", {
      header: "Sub Reference ID",
      size: 30,
    }),
    columnHelper.accessor("subscriptionId", {
      header: "Subscription ID",
      size: 30,
    }),
    columnHelper.accessor("isDeleted", {
      header: "Is Deleted",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original?.isDeleted ? "Yes" : "No"}
        </div>
      ),
    }),
    columnHelper.accessor("flag", {
      header: "Flag",
      size: 30,
    }),
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original.createdAt.split("T")[0]}
        </div>
      ),
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original.updatedAt.split("T")[0]}
        </div>
      ),
    }),
  ];

  return (
    <>
     {/*  */}
      <NameDateSearchComponent onSearch={handleSearchByDate} />
      <Box mt={2}>
        <CustomTable columns={columns} data={data}
          loading={stateLoading}
          permissionKey="MissingSIP"
        />
      </Box>
    </>
  );
}
